module.exports = __webpack_public_path__ + "c2bb2656c3907d5f87b4153cb73101a3.svg";